import { Capabilities, ProfileType } from '@/shared/types/capabilities';
import { InternalProfile } from '@/shared/types/internal-profile';

export type MockUser = {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  companyName?: string;
  consultantId?: string | null;
  avatarUrl?: string;
  lastLogin?: string;
  roles?: string[];
  /** Passer à 'INTERNAL' pour tester le gating des comptes internes en mode mock. */
  profileType?: ProfileType;
  /** Mode de rémunération : dérive `dividends` (true si REVENUE_SHARE ou PARTNER). */
  remunerationMode?: string;
  contractStart?: string | null;
  contractEnd?: string | null;
  internal?: InternalProfile | null;
};

/** Dérivation serveur reproduite pour le mock : cf. contrat `/auth/me`. */
export function deriveMockCapabilities(user: MockUser): Capabilities {
  const isInternal = (user.profileType ?? 'CONSULTANT') === 'INTERNAL';
  const isConsultant = !isInternal;
  return {
    missions: isConsultant,
    billing: isConsultant,
    externalValidation: isConsultant,
    finance: isConsultant,
    // Les internes gardent les NDF (jeu restreint), donc expenses reste true.
    expenses: true,
    // Carte « Ma rémunération » réservée aux comptes internes.
    internalRemuneration: isInternal,
  };
}

export type MockCredentials = {
  email: string;
  password: string;
};

export const mockUser: MockUser = {
  id: 'user_123',
  email: 'john.doe@example.com',
  firstName: 'John',
  lastName: 'Doe',
  fullName: 'John Doe',
  companyName: 'Freemakers Consulting',
  consultantId: null,
  avatarUrl: '',
  lastLogin: '2025-09-29',
  roles: ['user', 'admin'],
  profileType: 'CONSULTANT',
  remunerationMode: 'REVENUE_SHARE',
};

export const mockCredentials: MockCredentials = {
  email: 'john.doe@example.com',
  password: 'password123',
};

export const mockTokens = {
  accessToken: 'mock_access_token_abc',
  refreshToken: 'mock_refresh_token_xyz',
};

let currentAccessToken: string | null = null;

export function setMockAccessToken(token: string | null) {
  currentAccessToken = token;
}

export function getMockAccessToken() {
  return currentAccessToken;
}

export function resetAuthMockState() {
  currentAccessToken = null;
}
